<div
  *transloco="let t; scope: 'featureHighcharts'; prefix: 'featureHighcharts'"
  class="h-full flex flex-col pb-[32px]"
>
  <div
    class="flex flex-row justify-between items-center gap-x-3 py-5 pr-4 pl-8"
  >
    <span data-id="content-overview-title" class="bd-label-large">{{
      t('objectsOverview.title')
    }}</span>
    <p-button
      data-id="content-overview-close"
      [text]="true"
      [icon]="'ui-close'"
      styleClass="bd-neutral"
      (onClick)="close.emit(true)"
    >
    </p-button>
  </div>
  <p-tabs
    [value]="tab()"
    [dt]="tabsDt"
    class="bd-small-scrollbar bd-segment px-6 bd-content-overview-tabs overflow-auto"
  >
    <p-tablist>
      <p-tab
        id="tab-0"
        [value]="ContentOverviewTab.CONTENT"
        data-id="content-overview-content-tab"
        >{{ t('objectsOverview.objectsTab') }}</p-tab
      >
      <p-tab
        id="tab-1"
        [value]="ContentOverviewTab.SOURCE"
        data-id="content-overview-source-tab"
        >{{ t('objectsOverview.sourceTab') }}</p-tab
      >
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel
        [value]="ContentOverviewTab.CONTENT"
        data-id="content-overview-content-tabpanel"
      >
        <div class="flex flex-col flex flex-col bd-content-accordion">
          <p-accordion
            expandIcon="ui-down"
            collapseIcon="ui-up"
            [multiple]="true"
            [value]="['0']"
            class="bd-content-overview-accordion"
          >
            @let objects = objectsList();
            @if (objects && objects.length > 0) {
              <p-accordion-panel value="0">
                <p-accordion-header>
                  <ng-container
                    *ngTemplateOutlet="
                      tabHeaderTemplate;
                      context: {
                        badgeType: 'info',
                        title: 'objectsOverview.objectsList',
                        subtitle: 'objectsOverview.objectsListDescription',
                        objectsListLength: objects.length,
                      }
                    "
                  >
                  </ng-container>
                </p-accordion-header>
                <p-accordion-content>
                  <bd-content-overview-objects-list
                    data-id="content-overview-content-objects-list"
                    [objectsList]="objects"
                  ></bd-content-overview-objects-list
                ></p-accordion-content>
              </p-accordion-panel>
            }
          </p-accordion>
        </div>
      </p-tabpanel>
      <p-tabpanel
        [value]="ContentOverviewTab.SOURCE"
        data-id="content-overview-source-tabpanel"
      >
        <div class="flex flex-col">
          @if (sourceQuery()) {
            <div
              class="flex flex-col gap-4"
              data-id="content-overview-source-query"
            >
              <div class="bd-label-regular">
                {{ t('objectsOverview.sourceTabDescription') }}
              </div>
              @let term = searchTerm();
              @if (term) {
                <div class="bd-label-regular">
                  <span>{{ t('objectsOverview.searchTerm') }}</span>
                </div>
                <bd-searchbar
                  class="pb-4"
                  [disabled]="true"
                  [searchTerm]="term"
                ></bd-searchbar>
              }
              @let filters = appliedFilters();
              @if (filters && filters.length > 0) {
                <div class="bd-label-regular">
                  <span>{{ t('objectsOverview.filters') }}</span>
                </div>
                <bd-applied-filters [filters]="filters"></bd-applied-filters>
              }
              <div class="flex flex-col flex flex-col bd-source-accordion">
                <p-accordion
                  expandIcon="ui-down"
                  collapseIcon="ui-up"
                  [multiple]="true"
                  class="bd-content-overview-accordion"
                >
                  @let objects = objects$() | async;
                  @let selection = selectedIds();
                  @if (objects && objects.length > 0) {
                    <p-accordion-panel value="0">
                      <p-accordion-header>
                        <ng-container
                          *ngTemplateOutlet="
                            tabHeaderTemplate;
                            context: {
                              badgeType: 'info',
                              title: 'objectsOverview.selection',
                              subtitle: 'objectsOverview.selectionDescription',
                              objectsListLength: selection
                                ? '' + selection.length
                                : undefined,
                            }
                          "
                        >
                        </ng-container>
                      </p-accordion-header>
                      <p-accordion-content>
                        <bd-content-overview-objects-list
                          data-id="content-overview-source-objects-list"
                          [objectsList]="objects"
                          [selectedIds]="selection"
                          [showCheckboxes]="true"
                        ></bd-content-overview-objects-list
                      ></p-accordion-content>
                    </p-accordion-panel>
                  }
                </p-accordion>
              </div>
              <div class="bd-label-regular">
                {{ t('objectsOverview.sourceTabRefreshContentDescription') }}
              </div>
              @if (
                refreshActionButton() | translateActionButton | async;
                as action
              ) {
                <p-button
                  data-id="content-overview-source-refresh-action-button"
                  [bdActionButton]="action"
                  (onClick)="action.onClick($event)"
                  class="ml-auto"
                ></p-button>
              }
            </div>
          } @else {
            <div
              class="bd-label-regular"
              data-id="content-overview-source-no-query"
            >
              {{ t('objectsOverview.sourceTabNoSource') }}
            </div>
          }
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
  <ng-template
    #tabHeaderTemplate
    let-title="title"
    let-subtitle="subtitle"
    let-badgeType="badgeType"
    let-objectsListLength="objectsListLength"
  >
    <div class="w-full">
      @if (title && badgeType) {
        <div class="bd-label-regular">
          {{ t(title) }}
          <bd-badge
            [label]="
              objectsListLength
                ? '' + objectsListLength
                : t('objectsOverview.badgeAll')
            "
            [type]="badgeType"
            customIcon=""
            class="pl-2"
          ></bd-badge>
        </div>
      }
      @if (subtitle) {
        <div class="bd-caption">
          {{ t(subtitle) }}
        </div>
      }
    </div></ng-template
  >
</div>
